import React, { useState } from "react";
import { CardLabel, FormStep, RadioOrSelect, TextInput, SubmitBar, Loader } from "@egovernments/digit-ui-react-components";

const LandAreaDetails = ({ t, onSelect, formData, currStep }) => {
  const currentCity = JSON.parse(sessionStorage.getItem("currentCity") || null);
  const currLocality = JSON.parse(sessionStorage.getItem("currLocality") || null);
  const currVillage = JSON.parse(sessionStorage.getItem("currVillage") || null);
  const [selectedCity, setSelectedCity] = useState(currentCity || formData[currStep.key]?.city || '');
  const [localities, setLocalities] = useState(selectedCity?.boundary || currentCity?.boundary || formData[currStep.key]?.city?.boundary || []);
  const [selectedLocality, setSelectedLocality] = useState(currLocality || formData[currStep.key]?.locality || null);
  const selectedLocalityIndex = localities?.findIndex((e) => e.name === selectedLocality?.name);
  const [villages, setVillages] = useState(selectedLocality?.children || localities?.[selectedLocalityIndex]?.children || []);
  const [village, setVillage] = useState(currVillage || formData[currStep.key]?.village || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [areaType, setAreaType] = useState(selectedLocality?.IsSpecialArea ? `Special Area` : `Planning Area` || formData[currStep.key]?.areaType || '');
  const { data: cities, isLoading } = Digit.Hooks.useTenants();
  const code = 'hp';
  const applicationFlow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const citymoduleList = !isLoading && applicationFlow ? cities?.filter((city) => city.code?.includes(applicationFlow.toLowerCase())) : [];

  const handleSubmit = () => {
    const landAreaDetails = {}
    landAreaDetails.city = selectedCity?.name || "";
    landAreaDetails.tenantId = code;
    landAreaDetails.locality = selectedLocality || "";
    landAreaDetails.areaType = areaType || "";
    landAreaDetails.village = village || "";

    onSelect(currStep.key, landAreaDetails);
  };

  function selectCity(city) {
    setSelectedCity(city);
    setLocalities(city.boundary);
    setOpenVillage(false);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType('');
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    Digit?.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails["city"] = city;
  }

  function selectLocality(locality) {
    if (formData?.landAreaDetails?.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    const boundaryIndex = localities?.findIndex((e) => e.name === locality.name)
    setSelectedLocality(locality);
    setVillages(localities?.[boundaryIndex]?.children)
    setOpenVillage(true)
    setAreaType(localities?.[boundaryIndex]?.IsSpecialArea ? `Special Area` : `Planning Area`)
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }

  function selectVillage(village) {
    if (formData?.landAreaDetails?.village) {
      formData.landAreaDetails["village"] = village;
    }
    setVillage(village)
    sessionStorage.setItem("currVillage", JSON.stringify(village));
  }

  if (isLoading) { return <Loader /> }

  return (
    <FormStep
      cardStyle={{ boxShadow: 'none', padding: 0, border: 0 }}
      isDisabled={!selectedCity || !selectedLocality}
      onSelect={handleSubmit}
      isMultipleAllow={true}
      t={t}
    >
      <CardLabel>{`${t("BPA_DISTRICT_LABEL")}*`}</CardLabel>
      {/*
      <TextInput
        t={t}
        type={"text"}
        isMandatory={false}
        optionKey="i18nKey"
        name="district"
        value={selectedCity}
        onChange={selectCity}
        disabled={true}
      />
      */}
      <RadioOrSelect
        t={t}
        optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
        options={citymoduleList}
        selectedOption={selectedCity}
        onSelect={selectCity}
        optionKey="name"
        placeholder={`Select ${t("BPA_DISTRICT_LABEL")}`}
      />

      {(selectedCity && tcpCode && localities?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={selectedLocality}
            onSelect={selectLocality}
            t={t}
            isDependent={true}
          />
        </span>
      )}

      {(selectedCity && udCode && localities?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_ULB-AREA_LABEL")}*`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={selectedLocality}
            onSelect={selectLocality}
            t={t}
            isDependent={true}
          />
        </span>
      )}

      {(selectedCity && villageOpen && tcpCode && localities?.length > 0) && (
        <div>
          <CardLabel>{`${t("BPA_AREA_TYPE_LABEL")}`}</CardLabel>
          <TextInput
            t={t}
            type={"text"}
            optionKey="i18nKey"
            name="areaType"
            value={areaType}
            disabled={true} />
        </div>
      )}

      {(selectedCity && villageOpen && tcpCode && villages?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_VILLAGE-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={villages?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={village}
            onSelect={selectVillage}
            t={t}
            isDependent={true}
          />
        </span>
      )}

      {(selectedCity && villageOpen && udCode && villages?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_WARD-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={villages?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={village}
            onSelect={selectVillage}
            t={t}
            isDependent={true}
          />
        </span>
      )}
      <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit} style={{ marginTop: '1rem' }} />
    </FormStep>
  );
};

export default LandAreaDetails;
